namespace TabAurous.Sales {
    export interface RateFixingItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        PartyId: Serenity.IntegerEditor;
        RefVoucherId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        CertificateNo: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        RoutingId: Serenity.DecimalEditor;
        GroupId: Serenity.DecimalEditor;
        Studded: Serenity.IntegerEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        DesignId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        HasBom: Serenity.BooleanEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: Serenity.LookupEditor;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        MetalId: Serenity.IntegerEditor;
        KaratId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        StoneRate: AmountEditor;
        OtherRate: AmountEditor;
        UnitLabour: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        Line_No: Serenity.StringEditor;
        HSN: Serenity.LookupEditor;
        NetWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: WeightEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        MetalAmount: Serenity.DecimalEditor;
        DiamondAmount: Serenity.DecimalEditor;
        StoneAmount: Serenity.DecimalEditor;
        OtherAmount: Serenity.DecimalEditor;
        CalcOnId: Serenity.LookupEditor;
        UnitCost: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        WstPer: Serenity.DecimalEditor;
        WstWt: WeightEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
    }

    export class RateFixingItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Sales.RateFixingItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RateFixingItemsForm.init)  {
                RateFixingItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.LookupEditor;
                var w5 = CommonSubCategoryLookup;
                var w6 = WeightEditor;
                var w7 = AmountEditor;
                var w8 = s.DateEditor;

                Q.initFormType(RateFixingItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'PartyId', w1,
                    'RefVoucherId', w1,
                    'BagNo', w0,
                    'SKU', w0,
                    'LotNo', w0,
                    'CertificateNo', w0,
                    'RefNo', w0,
                    'RoutingId', w2,
                    'GroupId', w2,
                    'Studded', w1,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'DesignId', w0,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'DesignCode', w0,
                    'HasBom', w3,
                    'AttributeId', w0,
                    'ProductTypeId', w4,
                    'CategoryId', w4,
                    'SubCategoryId', w5,
                    'BrandId', w4,
                    'SuperTypeId', w4,
                    'CollectionId', w4,
                    'MetalId', w1,
                    'KaratId', w4,
                    'Pieces', w1,
                    'Weight', w6,
                    'UnitRate', w2,
                    'StoneRate', w7,
                    'OtherRate', w7,
                    'UnitLabour', w2,
                    'NetAmount', w2,
                    'GrossAmount', w2,
                    'CCNetAmount', w2,
                    'CCGrossAmount', w2,
                    'Line_No', w0,
                    'HSN', w4,
                    'NetWeight', w6,
                    'DiamondPieces', w1,
                    'DiamondWeight', w6,
                    'StonePieces', w1,
                    'StoneWeight', w6,
                    'OtherPieces', w1,
                    'OtherWeight', w6,
                    'Purity', w2,
                    'PureWeight', w6,
                    'MetalAmount', w2,
                    'DiamondAmount', w2,
                    'StoneAmount', w2,
                    'OtherAmount', w2,
                    'CalcOnId', w4,
                    'UnitCost', w2,
                    'Discount', w2,
                    'WstPer', w2,
                    'WstWt', w6,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w8,
                    'CompanyId', w1,
                    'BagStatus', w0
                ]);
            }
        }
    }
}
